setTimeout(() => {
  const menu = document.querySelector(".artist-header__menu");
  const activeItem = menu?.querySelector(".artist-header__link.is-active")?.closest(".artist-header__item");

  if (!menu || !activeItem) return;

  const menuRect = menu.getBoundingClientRect();
  const itemRect = activeItem.getBoundingClientRect();
  const scrollLeft = menu.scrollLeft + (itemRect.left - menuRect.left) - menuRect.width / 2 + itemRect.width / 2;

  menu.scrollTo({ left: Math.max(0, scrollLeft), behavior: "instant" });
}, 50);
